import React from "react";
import Footer from "./Footer";
import "../css/shop.scss";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";
import Header from "./Header";

function Shop() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="shop main">
      <Header />

      <main className="shop-products">
        <div className="shop-products__inner">
          <div className="shop-products__grid">
            {productData.map((product) => {
              const rawPrice = Number(product.price);
              const originalPrice = Number.isFinite(rawPrice) ? rawPrice : 0;
              const salePrice = Number.isFinite(rawPrice) ? rawPrice * 0.75 : 0;

              const brand = product.brand || "Denowl";
              const colorsCount = Array.isArray(product.colors)
                ? product.colors.length
                : 0;
              const isNew = product.id % 3 === 0;
              const primaryImageSrc =
                (Array.isArray(product.images) && product.images[0]) ||
                product.image;

              return (
                <Link
                  key={product.id}
                  to={`/shopDetails/${product.id}`}
                  className="shop-product"
                  onClick={toTop}
                >
                  <div className="shop-product__image">
                    <div className="shop-product__quick" aria-hidden="true" />
                    <img
                      src={primaryImageSrc}
                      alt={product.name}
                      loading="lazy"
                      decoding="async"
                      width="320"
                      height="280"
                    />
                  </div>

                  <div className="shop-product__meta">
                    <div className="shop-product__brand">{brand}</div>
                    <div className="shop-product__name">{product.name}</div>

                    <div className="shop-product__prices">
                      <span className="shop-product__priceOriginal">
                        $
                        {originalPrice.toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </span>
                      <span className="shop-product__priceSale">
                        $
                        {salePrice.toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </span>
                    </div>

                    <div className="shop-product__discount">25% off</div>
                    <div className="shop-product__colors">
                      {colorsCount} Colors
                    </div>
                    {isNew && (
                      <div className="shop-product__new">NEW ARRIVAL</div>
                    )}
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Shop;
